/* ==========================================================================
   LUX — Collection page

   Three small jobs:
     1. the sort control submits its form on change;
     2. the filter drawer opens and closes;
     3. a size button on a card retargets that card's Add to cart button.

   Adding to the cart itself is NOT here: assets/lux-cart.js already listens
   for [data-lux-quick-add] anywhere on the page, posts to /cart/add.js,
   updates the header count and opens the cart drawer. This file only has to
   keep that button pointed at the right variant.

   Listeners are delegated on document and bound once, so a Theme Editor
   re-render of the section needs no re-initialisation.
   ========================================================================== */

(function () {
  'use strict';

  var body = document.body;
  var releaseTrap = null;

  function filterDrawer() {
    return document.querySelector('[data-lux-filters]');
  }

  /* ---------------------------------------------------------------------
     1. Sort and filter — one GET form, submitted on change

     Empty controls are disabled first so the browser leaves them out of the
     query string. Without this, simply changing the sort order appends
     `&filter.v.price.gte=&filter.v.price.lte=` — harmless to Shopify, but it
     makes a shared URL look like a price filter is applied when none is, and
     it is what the customer sees in the address bar.

     The inputs are re-enabled on a timer as a safety net: if the navigation
     is cancelled (the customer hits Escape, or a beforeunload handler stops
     it) the form must not be left with dead controls.
     --------------------------------------------------------------------- */

  function submitFacets(form) {
    if (!form) return;

    var emptied = [];
    var controls = form.querySelectorAll('input[type="number"], input[type="text"]');

    for (var i = 0; i < controls.length; i++) {
      if (controls[i].value === '' && !controls[i].disabled) {
        controls[i].disabled = true;
        emptied.push(controls[i]);
      }
    }

    window.setTimeout(function () {
      for (var j = 0; j < emptied.length; j++) emptied[j].disabled = false;
    }, 1500);

    form.submit();
  }

  document.addEventListener('change', function (e) {
    var select = e.target.closest ? e.target.closest('[data-lux-facet-auto]') : null;
    if (!select) return;
    submitFacets(select.closest('[data-lux-facet-form]'));
  });

  /* A real submit (the drawer's "Show results" button) goes through the same
     cleanup, then lets the browser carry on. */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest ? e.target.closest('[data-lux-facet-form]') : null;
    if (!form) return;

    var controls = form.querySelectorAll('input[type="number"], input[type="text"]');
    for (var i = 0; i < controls.length; i++) {
      if (controls[i].value === '') controls[i].disabled = true;
    }
  });

  /* ---------------------------------------------------------------------
     2. Filter drawer

     Reuses the header's overlay, scroll lock and focus trap (assets/
     lux-header.js puts them on window.LuxUI) so this panel behaves like the
     menu and cart drawers. Each call is guarded: if the header script has
     not run, the drawer still opens — just without the extras.
     --------------------------------------------------------------------- */

  function openFilters() {
    var drawer = filterDrawer();
    if (!drawer) return;

    body.classList.add('lux-filters-open');
    drawer.setAttribute('aria-hidden', 'false');

    var btn = document.querySelector('[data-lux-filters-open]');
    if (btn) btn.setAttribute('aria-expanded', 'true');

    if (window.LuxUI && window.LuxUI.lockScroll) window.LuxUI.lockScroll();
    if (window.LuxUI && window.LuxUI.trapFocus) releaseTrap = window.LuxUI.trapFocus(drawer, closeFilters);
  }

  function closeFilters() {
    if (!body.classList.contains('lux-filters-open')) return;

    var drawer = filterDrawer();
    body.classList.remove('lux-filters-open');
    if (drawer) drawer.setAttribute('aria-hidden', 'true');

    var btn = document.querySelector('[data-lux-filters-open]');
    if (btn) btn.setAttribute('aria-expanded', 'false');

    if (releaseTrap) { releaseTrap(); releaseTrap = null; }
    if (window.LuxUI && window.LuxUI.unlockScroll) window.LuxUI.unlockScroll();
  }

  /* ---------------------------------------------------------------------
     3. Size buttons
     --------------------------------------------------------------------- */

  function chooseSize(button) {
    var card = button.closest('[data-lux-card]');
    if (!card) return;

    var variantId = button.getAttribute('data-variant-id');
    if (!variantId) return;

    var buttons = card.querySelectorAll('[data-lux-card-size]');
    for (var i = 0; i < buttons.length; i++) {
      var on = buttons[i] === button;
      buttons[i].classList.toggle('is-selected', on);
      buttons[i].setAttribute('aria-pressed', on ? 'true' : 'false');
    }

    var add = card.querySelector('[data-lux-card-add]');
    if (add) add.setAttribute('data-variant-id', variantId);
  }

  /* ---------------------------------------------------------------------
     Wire up
     --------------------------------------------------------------------- */

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;

    if (e.target.closest('[data-lux-filters-open]')) {
      e.preventDefault();
      openFilters();
      return;
    }

    if (e.target.closest('[data-lux-filters-close]')) {
      e.preventDefault();
      closeFilters();
      return;
    }

    /* The overlay is shared with the header's own panels, so only claim a
       click on it while the filter drawer is what is open. */
    if (e.target.closest('[data-lux-overlay]') && body.classList.contains('lux-filters-open')) {
      closeFilters();
      return;
    }

    var size = e.target.closest('[data-lux-card-size]');
    if (size) {
      /* The card's title link lays a click target across the whole card;
         stop the event before it gets there or picking a size would
         navigate to the product page. */
      e.preventDefault();
      e.stopPropagation();
      chooseSize(size);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && body.classList.contains('lux-filters-open')) closeFilters();
  });

  /* A Theme Editor re-render replaces the drawer element, so drop any state
     pointing at the old one. */
  document.addEventListener('shopify:section:load', function () {
    if (body.classList.contains('lux-filters-open')) closeFilters();
  });
})();
